import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import styles from './CircleImage.module.scss';
import { BRAND } from '../../constants/brand';

interface CircleImageProps {
  className?: string;
  images: string[];
}

const CircleImage: FunctionComponent<CircleImageProps> = ({
  className,
  images,
}) => {
  const circleImageClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-circle-image`,
    className,
    {
      [styles.circleImage]: true,
    },
  );

  return (
    <div className={circleImageClass}>
      {images.map(image => (
        <div className={styles.imageContainer} key={image}>
          <img src={`/images/circles/${image}.jpg`} aria-hidden alt="" />
        </div>
      ))}
    </div>
  );
};

export default CircleImage;
